// sherlock-freetrial.js
import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import { callGetApi, callPostApi, callPatchApi, callDeleteApi } from "@/utils/apiWrapper";

export const state = {};

export const mutations = {};

export const actions = {
  /**************************************************************
   * 무료체험 시작
   **************************************************************/
  async acPostStartSherlockFreeTrial({ commit }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_START_SHERLOCK_FREE_TRIAL}`,
      params: {},
      commit,
    });
    // window.console.log("[acPostStartSherlockFreeTrial] res: ", res);
    return res;
  },

  /**************************************************************
   * 셜록 카카오페이 카드 등록
   **************************************************************/
  async acPostSherlockPortoneCardRegister({ commit }, { billing_key }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_PORTONE_CARD_REGISTER}`,
      params: {},
      data: {
        billing_key,
      },
      commit,
    });
    // window.console.log("[acPostSherlockPortoneCardRegister] res: ", res);
    return res;
  },

  /**************************************************************
   * 셜록 무료체험 자동 충전 금액 변경
   **************************************************************/
  async acPostSherlockChangeRechargeAmount({ commit }, { product_code }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_CHANGE_RECHARGE_AMOUNT}`,
      params: {},
      data: {
        product_code,
      },
      commit,
    });
    // window.console.log("[acPostSherlockChangeRechargeAmount] res: ", res);
    return res;
  },

  /**************************************************************
   * 셜록 무료체험 포인트 자동 충전
   **************************************************************/
  async acPostSherlockAutoChargePoint({ commit }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_AUTO_CHARGE_POINT}`,
      params: {},
      data: {},
      commit,
    });
    if (process.env.NODE_ENV === "development") {
      window.console.log("[acPostSherlockAutoChargePoint] res: ", res);
    }
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
